// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-docs-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.compact-create-docs{
  
    width: 95%;
   height: 95%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}
.create-docs-titulo{
    font-size: var(--font-size-large);
    font-weight: bold;
    border-bottom: 1px solid rgba(128, 128, 128, 0.349);
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--main-color);
}
.create-docs-body{
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.create-docs-footer{
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}       
.cont-msg-alert-create-docs{
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
   
}
.cont-msg-create-docs{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
   
}
.compact-msg-alert-create-docs{
    width: 90%;
    height: 80%;
    border: 2px solid rgb(214, 214, 27);
    background-color:rgba(255, 255, 151, 0.589);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    text-align: center;
    font-size: var(--font-size-medium);
    color: var(--txt-color);
}
.compact-msg-create-docs{
    width: 90%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    font-size: var(--font-size-medium);
    color: var(--txt-color);
}
.cont-datos-create-docs{
    width: 100%;
    height: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: auto;
}
.compact-datos-create-docs{
   width: 80%;
  height: 90%;
  display: flex;
  justify-content: start;
  align-items: start;
  text-align: start;
  flex-direction: column;
  color: var(--txt-color);
}
.row-change-create-docs{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}
.label-create-docs-title{
    font-size: var(--font-size-medium);
    font-weight: bold;
    margin-right: 10px;
    color: var(--third-color);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: start;
width: 33%;
}
.change-values-create-docs{
    font-size: var(--font-size-medium);
    color: var(--txt-color);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 67%;
}
.old-value-create-docs{
    
    margin-right: 10px;
    color: var(--error-color);
    width: 47%;
    display: flex  ;
    justify-content: center;
    align-items: center;
}
.arrow-change-create-docs{
    font-size: var(--font-size-large);
    margin-right: 10px;
    color: var(--txt-color);
    width: 6%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.new-value-create-docs{
    color: var(--green);
    width: 47%;
    display: flex  ;
    justify-content: center;
    align-items: center;
}


.create-docs-options {
  font-size: var(--font-size-large);
  font-weight: bold;
  border-bottom: 1px solid rgba(128, 128, 128, 0.349);
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--main-color);
}

/*  */
.fileType-tab-container {
  display: flex;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  overflow: hidden;
  width: 60%;
}

.fileType-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  background: #fff;
  transition: 0.2s;
  width: 50%;
}

.fileType-tab input {
  display: none;
  width: 100%;
}

.fileType-tab.active {
  background: #007bff;
  color: white;
}

.fileType-tab.active .icon {
  color: white;
}

.fileType-tab:not(.active):hover {
  background: #f3f3f3;
}
.fileType-tab{
    display: flex;
  align-items: center;
  gap: 6px; 
  justify-content: center;
}
.FileIcon {
  font-size: 16px;
}
/* file */
.pdf-upload-container {
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label-title {
  font-size: 15px;
  font-weight: 500;
  color: #555;
}

.required {
  color: red;
}

.drop-zone {
  border: 2px dashed #c5c5c5;
  padding: 38px;
  text-align: center;
  border-radius: 12px;
  font-size: 17px;
  color: #505050;
  cursor: pointer;
  transition: 0.25s ease;
  background: #fafafa;
}

.drop-zone strong {
  color: #333;
}

.drop-zone:hover {
  background: #f2f2f2;
}

.drop-zone.active {
  border-color: #007bff;
  background: #eaf3ff;
  color: #0056c7;
}
.file-name {
  margin-top: 12px;
  font-size: 16px;
  color: #007bff;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/cis-components/styles/ModalCreateDocs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,UAAU;GACX,WAAW;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,mDAAmD;IACnD,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;AACA;GACG,UAAU;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B,UAAU;AACV;AACA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;AACA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mDAAmD;EACnD,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,KAAK;AACL;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;AACA;IACI,aAAa;EACf,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA,SAAS;AACT;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B","sourcesContent":[".create-docs-container{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.compact-create-docs{\r\n  \r\n    width: 95%;\r\n   height: 95%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n.create-docs-titulo{\r\n    font-size: var(--font-size-large);\r\n    font-weight: bold;\r\n    border-bottom: 1px solid rgba(128, 128, 128, 0.349);\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--main-color);\r\n}\r\n.create-docs-body{\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n.create-docs-footer{\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n}       \r\n.cont-msg-alert-create-docs{\r\n    width: 100%;\r\n    height: 15%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   \r\n}\r\n.cont-msg-create-docs{\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   \r\n}\r\n.compact-msg-alert-create-docs{\r\n    width: 90%;\r\n    height: 80%;\r\n    border: 2px solid rgb(214, 214, 27);\r\n    background-color:rgba(255, 255, 151, 0.589);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n}\r\n.compact-msg-create-docs{\r\n    width: 90%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n}\r\n.cont-datos-create-docs{\r\n    width: 100%;\r\n    height: 75%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n}\r\n.compact-datos-create-docs{\r\n   width: 80%;\r\n  height: 90%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: start;\r\n  text-align: start;\r\n  flex-direction: column;\r\n  color: var(--txt-color);\r\n}\r\n.row-change-create-docs{\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n.label-create-docs-title{\r\n    font-size: var(--font-size-medium);\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n    color: var(--third-color);\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: start;\r\nwidth: 33%;\r\n}\r\n.change-values-create-docs{\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 67%;\r\n}\r\n.old-value-create-docs{\r\n    \r\n    margin-right: 10px;\r\n    color: var(--error-color);\r\n    width: 47%;\r\n    display: flex  ;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.arrow-change-create-docs{\r\n    font-size: var(--font-size-large);\r\n    margin-right: 10px;\r\n    color: var(--txt-color);\r\n    width: 6%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.new-value-create-docs{\r\n    color: var(--green);\r\n    width: 47%;\r\n    display: flex  ;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.create-docs-options {\r\n  font-size: var(--font-size-large);\r\n  font-weight: bold;\r\n  border-bottom: 1px solid rgba(128, 128, 128, 0.349);\r\n  width: 100%;\r\n  height: 10%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--main-color);\r\n}\r\n\r\n/*  */\r\n.fileType-tab-container {\r\n  display: flex;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  width: 60%;\r\n}\r\n\r\n.fileType-tab {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px 18px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #555;\r\n  background: #fff;\r\n  transition: 0.2s;\r\n  width: 50%;\r\n}\r\n\r\n.fileType-tab input {\r\n  display: none;\r\n  width: 100%;\r\n}\r\n\r\n.fileType-tab.active {\r\n  background: #007bff;\r\n  color: white;\r\n}\r\n\r\n.fileType-tab.active .icon {\r\n  color: white;\r\n}\r\n\r\n.fileType-tab:not(.active):hover {\r\n  background: #f3f3f3;\r\n}\r\n.fileType-tab{\r\n    display: flex;\r\n  align-items: center;\r\n  gap: 6px; \r\n  justify-content: center;\r\n}\r\n.FileIcon {\r\n  font-size: 16px;\r\n}\r\n/* file */\r\n.pdf-upload-container {\r\n  width: 95%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.label-title {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #555;\r\n}\r\n\r\n.required {\r\n  color: red;\r\n}\r\n\r\n.drop-zone {\r\n  border: 2px dashed #c5c5c5;\r\n  padding: 38px;\r\n  text-align: center;\r\n  border-radius: 12px;\r\n  font-size: 17px;\r\n  color: #505050;\r\n  cursor: pointer;\r\n  transition: 0.25s ease;\r\n  background: #fafafa;\r\n}\r\n\r\n.drop-zone strong {\r\n  color: #333;\r\n}\r\n\r\n.drop-zone:hover {\r\n  background: #f2f2f2;\r\n}\r\n\r\n.drop-zone.active {\r\n  border-color: #007bff;\r\n  background: #eaf3ff;\r\n  color: #0056c7;\r\n}\r\n.file-name {\r\n  margin-top: 12px;\r\n  font-size: 16px;\r\n  color: #007bff;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
